import { createContext, useContext } from 'react'

import type { AuthContextType } from './AuthProvider'
import { bearerToken } from '@/utils'

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be within the <AuthProvider />')
  }
  return context
}

export type AuthHeaders = {
  Authorization: string
}

export const useAuthHeaders = (): AuthHeaders => {
  const { access_token } = useAuth()
  if (access_token) {
    return { Authorization: bearerToken(access_token) }
  }
  return { Authorization: '' }
}
